module.exports = __webpack_public_path__ + "assets/img/iphone-icon.5088c014.png";